import { render, staticRenderFns } from "./PaySectionToolPage.vue?vue&type=template&id=645ee210&"
import script from "./PaySectionToolPage.vue?vue&type=script&lang=js&"
export * from "./PaySectionToolPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports